const formatDate = (date: Date): string => {
  const formattedDate = date.getUTCDate() + '-' + (date.getUTCMonth() + 1) + '-' + date.getUTCFullYear();
  return formattedDate;
};

export default formatDate;
